import { Injectable } from '@angular/core';
import { ReportApiService } from '@agent-portal/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { ReportAction } from '../actions';

@Injectable()
export class ReportEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(ReportAction.loadItem),
      exhaustMap(action => {
        return this._apiService.get(action.id).pipe(map(item => ReportAction.loadItemSuccess({ item })));
      })
    );
  });
  constructor(private _apiService: ReportApiService, private _actions$: Actions, private _store: Store) {}
}
